export enum LoadingSpinnerIntent {
  Primary = "primary",
  Secondary = "secondary",
  Danger = "danger",
}
